import React, { useEffect } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { flattenArray, hasKeys, isEmptyArray } from 'utils';
import { withRouter } from 'react-router-dom';
import Dropdown from './select-field';

export default withRouter(({
  label = 'IP (v4)',
  value,
  onChange,
  error,
  passedIps,
  style = {},
  onlySelect = false,
  isLoadDataCenter = true,
  match,
}) => {
  const { id, dcId } = match.params;
  let { [ACTIONS_TYPES.IP.GET_ALL]: ips = [] } = useSelector((e) => e);
  if (Array.isArray(passedIps)) ips = passedIps;

  const { [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter = {} } = useSelector((e) => e);
  const { properties: dcProps = {} } = datacenter;

  ips = ips.filter(({ properties }) => properties?.location === dcProps?.location).map(({ properties }) => properties?.ips || []);
  ips = flattenArray(ips);

  const changeHandler = (e, newValue) => (newValue
    ? onChange(newValue)
    : onChange(e.target.value || ''));

  useEffect(() => {
    if (!passedIps) actions.ip.getAll();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!hasKeys(datacenter) && isLoadDataCenter) actions.dataCenter.get({ id: dcId || id });
    // eslint-disable-next-line
  }, [isLoadDataCenter, id, dcId]);

  return (
    onlySelect ? (
      <Dropdown
        style={{
          width: '100%', ...style,
        }}
        label={label}
        value={value}
        onChange={(e) => changeHandler(e)}
        values={ips}
        error={error}
      />
    ) : (
      isEmptyArray(ips) ? (
        <TextField
          label={label}
          variant="outlined"
          fullWidth
          value={value}
          onChange={changeHandler}
          error={!!error}
          helperText={error}
          style={style}
        />
      ) : (
        <Autocomplete
          options={ips.filter((e) => e.includes(value))}
          getOptionLabel={(option) => option}
          style={style}
          value={value || null}
          onChange={changeHandler}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              fullWidth
              value={value}
              onChange={changeHandler}
              error={!!error}
              helperText={error}
            />
          )}
        />
      )));
});
